import { useEffect, useRef } from "react";
import "./animatedTabContent.css";

const AnimatedTabContent = ({ activeTab, order = [], className = "", children }) => {
  const prevTabRef = useRef(activeTab);

  const prevIndex = order.indexOf(prevTabRef.current);
  const currIndex = order.indexOf(activeTab);
  const direction = prevIndex >= 0 && currIndex < prevIndex ? "left" : "right";

  useEffect(() => {
    prevTabRef.current = activeTab;
  }, [activeTab]);

  return (
    <div
      key={activeTab}
      className={`animated-tab-content animated-tab-content--${direction} ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedTabContent;
